<script>
    export default {
        data(){
            return {
                active: false
            }
        },
        computed: {
            modalID() {
                return this.item.objectID || this.item.productId
            },
            name(){
                return this.item.title || this.item.name
            },
            modal(){
                return $(`[data-remodal-id='${this.modalID}']`).remodal()
            },
            item(){
                return this.result
            }
        },
        methods: {
            open() {
                this.active = true;
                this.modal.open();
            },
            close() {
                this.active = false;
                this.modal.close();
            }
        },
        props: ['result']
    }
</script>
